
import objectPath from 'object-path'

const getters = {
  getField: state => target => objectPath.get(state, target),
  getEditFormModal: state => state.editFormModal,
  getEditForm: state => state.editForm,
  getParticipationFormModal: state => state.participationFormModal,
  getParticipationForm: state => state.participationForm,
  getProgramModal: state => state.programModal,
  getPagination: state => state.pagination,
  isLoading: state => state.isLoading,
  isLoadingMore: state => state.isLoadingMore,
  isLoadingMoreBlocked: state => state.isLoadingMoreBlocked,
  isControls: state => state.isControls,
  getCollection: state => state.collection,
  hasError: state => state.hasError,
  getSearchForm: state => ({
    ...state.form,
    page: state.pagination.page,
    perPage: state.pagination.perPage
  }),
  getFiltersCollection: state => state.filtersCollection,
  getResponsibleUsers: state => state.responsibleUsers
}

export default getters